import React from "react"
import "./Buttons.css"
import { Icon } from 'semantic-ui-react'
import ReactTooltip from "react-tooltip";

function JumpToTopButton(){
  return (
    <a onClick={() => {
      document.querySelector(".page-container-header").scrollIntoView({ behavior: "smooth" })
    }}>
      <Icon name="angle double up" circular inverted size="big"
            className="btn btn-primary button-component jump-to-top-btn" data-tip="Jump To Top" data-for="tooltipid">
      </Icon>
      <ReactTooltip place="top" backgroundColor="rgb(47, 224, 222)" id="tooltipid" effect="solid" />
    </a>
  )
}

export default JumpToTopButton